<template lang="">
  <div>
    <div class="vx-row ">
      <div class="vx-col w-full mb-4">
        <date-range-picker
          ref="picker"
          :locale-data="{ direction: 'ltr',
                          format: 'mm/dd/yyyy',
                          separator: ' - ',
                          applyLabel: 'Valider',
                          cancelLabel: 'Annuler',
                          weekLabel: 'W',
                          customRangeLabel: 'Custom Range',
                          daysOfWeek: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
                          monthNames: ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                          firstDay: 0
                        }"
          v-model="dateRange"
          :ranges="{
            'Today': [today, new Date(today.getFullYear(), today.getMonth(), today.getDate(), 11, 59, 59, 999)],
            'Yesterday': [new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1), new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1, 11, 59, 59, 999)],
            'This month': [new Date(today.getFullYear(), today.getMonth(), 1), new Date(today.getFullYear(), today.getMonth() + 1, 0, 11, 59, 59, 999)],
            'Last month': [new Date(today.getFullYear(), today.getMonth() - 1, 1),new Date(today.getFullYear(), today.getMonth(), 0, 11, 59, 59, 999)],
            'This year': [new Date(today.getFullYear(), 0, 1),new Date(today.getFullYear(), 11, 31, 11, 59, 59, 999)],
            'Last year': [new Date(today.getFullYear() - 1, 0, 1),new Date(today.getFullYear() - 1, 11, 31, 11, 59, 59, 999)]
          }"
        >
            <template v-slot:input="picker" style="min-width: 350px;">
            <feather-icon icon="CalendarIcon" svgClasses="h-4 w-4" />
                {{ picker.startDate | moment("DD-MMMM-YYYY") }} - {{ picker.endDate | moment("DD-MMMM-YYYY") }}
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />

            </template>

             <!--    ranges (new slot syntax) -->
            <template #ranges="ranges">
              <div class="ranges">
                <ul>
                  <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                    <b v-if="name == 'Today'">Aujourd'hui</b>
                    <b v-if="name == 'Yesterday'"> Hier</b>
                    <b v-if="name == 'This month'"> Ce mois</b>
                    <b v-if="name == 'This year'"> Cette année</b>
                    <b v-if="name == 'Last month'">Mois dérnier</b>
                    <b v-if="name == 'Last year'">Année dérnière</b>
                  </li>
                </ul>
              </div>
            </template>
        </date-range-picker>

      </div>
    </div>


    <div class="vx-row" v-if="user_role === 'Admin' || user_role === 'User'">

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="ToolIcon"
          icon-right
          :statistic="filteredInvoices"
          statisticTitle="Nbrs des interventions" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="CalendarIcon"
          icon-right
          :statistic="filteredInvoicesCurrentDay"
          statisticTitle="Rdv pris du jour"
          color="warning" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UsersIcon"
          icon-right
          :statistic="countClientsHaveInvoice"
          statisticTitle="Nbrs des clients"
          color="success" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="UserIcon"
          icon-right
          :statistic="artisans.length"
          statisticTitle="Nbrs des artisans"
          color="danger" />
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/5 xl:w-1/5">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="totaleHt"
          statisticTitle="Chiffre d'affaire HT"
          color="warning" />
      </div>
    </div>

    <div class="vx-row" v-if="user_role === 'Artisan'">

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="ToolIcon"
          icon-right
          :statistic="filteredInvoicesByArtisan.length"
          statisticTitle="Nbrs des interventions" />
      </div>

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="totaleHtByArtisan"
          statisticTitle="Chiffre d'affaire HT"
          color="warning" />
      </div>

      <div class="vx-col w-full sm:w-1/3 md:w-1/3 lg:w-1/3 xl:w-1/3">
        <statistics-card-line
          hideChart
          class="mb-base"
          icon="DollarSignIcon"
          icon-right
          :statistic="ArtisanAFTotaleHt1"
          statisticTitle="Commission"
          color="warning" />
      </div>
    </div>

    <div class="vx-row mb-10"  v-if="user_role === 'Admin'  || user_role === 'User'">
      <div class="vx-col w-full">
        <vx-card title="Évolution CA">
          <vue-apex-charts ref="chart" type="area" height="350" :options="lineAreaChartSpline.chartOptions" :series="lineAreaChartSpline.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>

    <div class="vx-row mb-10"  v-if="user_role === 'Admin'">
      <div class="vx-col w-full">
        <vx-card title="Évolution Rdv pris par jour">
          <vue-apex-charts ref="chart" type="area" height="350" :options="daysLineArea.chartOptions" :series="daysLineArea.series"></vue-apex-charts>
        </vx-card>
      </div>
    </div>

    <div class="vx-row"  v-if="user_role === 'Admin'">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Autofactures impayées (en cours de traitement)">
              <vs-table :data="filteredWithAF" pagination search max-items="6">

                <template slot="thead">
                  <vs-th sort-key="fullName">Nom & Prénom</vs-th>
                  <vs-th sort-key="interventions_count">Nbrs inter.</vs-th>
                  <vs-th colspan="3">
                    <feather-icon icon="GitCommitIcon" svgClasses="w-5 h-5 text-danger" class="ml-5 mr-2"/> Commission
                  </vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                      {{ tr.fullName }}
                    </vs-td>

                    <vs-td>
                      <p @click="ToAF(tr.id)" class="cursor-pointer underline">{{ tr.interventions.length }}</p>
                    </vs-td>

                    <vs-td style="background: #ffa9a9;font-weight: bold;">
                      {{ ArtisanAFTotaleHt(tr) }}
                    </vs-td>


                  </vs-tr>
                </template>

              </vs-table>
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Les artisans">
              <vs-table :data="filteredWithInterventions" pagination search max-items="6">

                <template slot="thead">
                  <vs-th sort-key="fullName">Nom & Prénom</vs-th>
                  <vs-th sort-key="interventions_count">Nbrs inter.</vs-th>
                  <vs-th colspan="3">
                    <feather-icon icon="GitCommitIcon" svgClasses="w-5 h-5 text-success" class="mr-2"/> Revenus
                    <feather-icon icon="GitCommitIcon" svgClasses="w-5 h-5 text-danger" class="ml-5 mr-2"/> Commission
                  </vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                      {{ tr.fullName }}
                    </vs-td>

                    <vs-td>
                      <p @click="ToInterventions(tr.id)" class="cursor-pointer underline">{{ tr.interventions.length }}</p>
                    </vs-td>

                    <vs-td style="background: #cbffbe;font-weight: bold;">
                      {{ ArtisanTotaleHt(tr) }}
                    </vs-td>

                    <vs-td style="background: #ffa9a9;font-weight: bold;">
                      {{ ArtisanAFTotaleHt(tr) }}
                    </vs-td>

                    <vs-td width="170">
                      <vs-progress :height="7" :percent="ArtisanTotaleHtPercent(tr)" color="success" ></vs-progress>
                      <vs-progress :height="7" :percent="ArtisanAFTotaleHtPercent(tr)" color="danger" ></vs-progress>
                    </vs-td>

                  </vs-tr>
                </template>

              </vs-table>
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Nombre des interventions pris par secteur">
              <e-charts autoresize :options="intervenions_pris" auto-resize />

              <p class="text-center">
                <b>Nombres total des interventions pris : {{ nbrInterPris }}</b>
              </p>
            </vx-card>
          </div>
        </div>

      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2">
        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Les interventions annulées">
              <template slot="actions">
                <v-select class="w-64" :clearable="true" label="name" v-model="f_secteur_id" :options="secteurs_choice" :reduce="secteur => secteur.id" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <div slot="no-options">Désolé, aucun secteur correspondante.</div>
                </v-select>
              </template>
                

              <e-charts autoresize :options="intervenions_annuler_pie" auto-resize />

              <p class="text-center">
                <b>Nombres total des interventions annulés : {{ nbrInterAnnuler }}</b>
              </p>
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Les rendez-vous pris par utilisateurs">
              <e-charts autoresize :options="filteredNbrsInterventionsForUser" auto-resize />
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Chiffre d'affaire HT par utilisateur">
              <e-charts autoresize :options="filteredCAForUser" auto-resize />
            </vx-card>
          </div>
        </div>

        <div class="vx-row mb-10">
          <div class="vx-col w-full">
            <vx-card title="Nombre des interventions annulées par secteur">
              <e-charts autoresize :options="intervenions_annuler_secteurs" auto-resize />

              <p class="text-center">
                <b>Nombres total des interventions annulées : {{ nbrInterAnnuler }}</b>
              </p>
            </vx-card>
          </div>
        </div>

      </div>
    </div>

    <div class="vx-row"  v-if="user_role === 'Artisan'">
      <div class="vx-col w-full">
        <vx-card title="Les interventions d'aujourd'hui">
          <vs-table ref="table" pagination :max-items="itemsPerPage" :data="filteredInterventionsByArtisan" noDataText="Aucun intervention trouvé">
            <template slot="thead">

              <vs-th sort-key="num_intervention">N° Intervention</vs-th>
              <vs-th sort-key="lieu">Lieu Intervention</vs-th>
              <vs-th sort-key="date_intervention">Date de création</vs-th>
              <vs-th sort-key="client">Client</vs-th>
              <vs-th sort-key="status">Etat</vs-th>
            </template>

              <template slot-scope="{data}">
                <tbody>
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :class="{'font-bold': tr.from_web_site && tr.new}">

                    <vs-td>
                      <p @click.stop="showIntervention(tr)" class="num_object">BI{{ tr.id | strPadStart('0') }}</p>
                    </vs-td>

                    <vs-td>
                      <p>{{ tr.lieu }}</p>
                    </vs-td>

                    <vs-td>
                      <p>{{ tr.created_at | date }}</p>

                    </vs-td>

                    <vs-td>
                      <p>{{ tr.name_client }}</p>
                    </vs-td>

 
                    <vs-td>
                      <p>
                        <vs-chip v-if="tr.status == 0" color="warning">En attente</vs-chip>
                        <vs-chip v-if="tr.status == 1" color="dark">Validé</vs-chip>
                        <vs-chip v-if="tr.status == 2" color="primary">En cours</vs-chip>
                        <vs-chip v-if="tr.status == 3" color="success">Terminer</vs-chip>
                        <vs-chip v-if="tr.status == 4" color="danger">Refusé</vs-chip>
                      </p>
                    </vs-td>

                  </vs-tr>
                </tbody>
              </template>
          </vs-table>
        </vx-card>
      </div>
    </div>

  </div>
</template>
<script>
import vSelect from 'vue-select'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { mapGetters, mapActions } from "vuex"

import { moment } from 'vue-moment';

import VueApexCharts from 'vue-apexcharts'

import ECharts from 'vue-echarts/components/ECharts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie'


export default {

  components: {
    vSelect,
    StatisticsCardLine,
    DateRangePicker,
    moment,
    VueApexCharts,
    ECharts
  },
  data () {

    var date = new Date();
    let startDate = new Date(date.getFullYear(), date.getMonth(), 1);
    let endDate = new Date();
    //endDate.setDate(endDate.getDate() + 6)

    let today = new Date()
    today.setHours(0, 0, 0, 0)

    return {
      dateRange: {startDate, endDate},
      user_role : null,
      itemsPerPage : 6,
      nbrInterventionNotHasInvoice : 0,
      lineAreaChartSpline: {
        series: [{
            name: 'Nombre des interventions',
            data: []
          }, {
            name: 'Total Ht',
            data: []
        }],
        chartOptions: {
          dataLabels: {
            enabled: true
          },
          stroke: {
            curve: 'smooth'
          },
          colors:  ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          xaxis: {
            type: 'category',
            categories: [],
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        }
      },
      nbrInterAnnuler : 0,
      nbrInterPris: 0,
      f_secteur_id: null,
      today: today
    }
  },
  computed: {
    ...mapGetters('interventions', { 'interventions' : 'GET_ITEMS','artisan_interventions' : 'GET_ITEMS_ARTISAN', 'nbrsInterventionsForUser' : 'GET_ITEMS_NBR_INTERVENTION','interventionsHasInvoice' : 'GET_ITEMS_HAS_INVOICE' , 'interventionsDoesntHaveInvoice' : 'GET_ITEMS_DOESNT_HAVE_INVOICE'}),
    ...mapGetters('clients', { 'clients' : 'GET_ITEMS', 'countClientsHaveInvoice' : 'COUNT_CLIENTS_HAVE_INVOICE' }),
    ...mapGetters('artisans', { 'artisans' : 'GET_ITEMS', 'artisans_with_interventions': 'GET_ITEMS_WITH_INTERVENTIONS' }),
    ...mapGetters('invoices', { 'invoices' : 'GET_ITEMS' }),
    ...mapGetters('statistiques', { 'statis_artisans' : 'GET_ITEMS', 'statis_interventions' : 'GET_INTERVENTIONS_STATISTICS'}),
    ...mapGetters('secteurs', {'Secteurs' : 'GET_ITEMS_WITH_INTERVENTIONS','secteurs_liste' : 'GET_ITEMS'}),

    totaleHt() {
      return this.invoices.filter(item => {
        return this.format_date(item.date) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date) <= this.format_date(this.dateRange.endDate)
      }).reduce((sum, i) =>sum + i.ht, 0).toFixed(2)+ ' €'
    },

    totaleHtByArtisan() {
       return this.filteredInvoicesByArtisan.reduce((sum, i) =>sum + i.ht, 0).toFixed(2)+ ' €'
    },

    filteredInvoices(){
      return this.invoices.filter(item => {
        return item.date >= this.format_date(this.dateRange.startDate) && item.date <= this.format_date(this.dateRange.endDate)
      }).length
    },

    filteredInvoicesCurrentDay(){
      var date = new Date()
      return this.interventions.filter(item => {
        return this.format_date(item.created_at) >= this.format_date(date) && this.format_date(item.created_at) <= this.format_date(date) && (item.status == 2 || item.status == 3)
      }).length
    },

    filteredInvoicesByArtisan() {
      return this.invoices.filter(item => {
        return item.date >= this.format_date(this.dateRange.startDate) && item.date <= this.format_date(this.dateRange.endDate) && this.artisan_interventions.find(intervention => item.intervention_id == intervention.id) && item.status == 'paid'
      })
    },

    filteredArtisans(){
      return this.statis_artisans.filter(item => {
        return item.interventions.findIndex(intervention => (this.format_date(intervention.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.date_intervention) <= this.format_date(this.dateRange.endDate))) > -1
      })
    },

    filteredWithInterventions(){
      var filtered_artisans = this.artisans_with_interventions
      return filtered_artisans.map((artisan, index) => {
        var temp = Object.assign({}, artisan);
        temp.interventions = temp.interventions.filter(intervention => {
          return (this.format_date(intervention.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.date_intervention) <= this.format_date(this.dateRange.endDate))
        })

        return temp
      }).filter(item => item.interventions.length)
    },

    filteredWithAF(){
      var filtered_artisans = this.artisans_with_interventions
      return filtered_artisans.map((artisan, index) => {
        var temp = Object.assign({}, artisan);
        temp.interventions = temp.interventions.filter(intervention => {
          return intervention.auto_invoices.length ? (intervention.auto_invoices[0].status != 'paid' && this.format_date(intervention.auto_invoices[0].date) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.auto_invoices[0].date) <= this.format_date(this.dateRange.endDate)) : false
        })
        return temp
      }).filter(item => item.interventions.length)
    },

    ArtisanTotaleHt() {
      return tr => {
        return tr.interventions.length ? tr.interventions.reduce((sum, intervention) =>sum + (intervention.invoice ? intervention.invoice.ht : 0), 0).toFixed(2)+ ' €' : '0.00 €'
      }
    },

    ArtisanAFTotaleHt() {
      return tr => {
        return tr.interventions.length ? tr.interventions.reduce((sum, intervention) => sum + (intervention.auto_invoices.length ? intervention.auto_invoices[0].commission : 0), 0).toFixed(2)+ ' €' : '0.00 €'
      }
    },

    ArtisanTotaleHtPercent () {
      return tr => {
        var autoInvoices = tr.interventions.length ? tr.interventions.reduce((sum, intervention) => sum + (intervention.auto_invoices.length ? intervention.auto_invoices[0].commission : 0), 0) : 0
        var invoices = tr.interventions.length ? tr.interventions.reduce((sum, intervention) =>sum + (intervention.invoice ? intervention.invoice.ht : 0), 0) : 0
        return (invoices / (invoices + autoInvoices)) * 100
      }
    },

    ArtisanAFTotaleHtPercent () {
      return tr => {
        var autoInvoices = tr.interventions.length ? tr.interventions.reduce((sum, intervention) => sum + (intervention.auto_invoices.length ? intervention.auto_invoices[0].commission : 0), 0) : 0
        var invoices = tr.interventions.length ? tr.interventions.reduce((sum, intervention) =>sum + (intervention.invoice ? intervention.invoice.ht : 0), 0) : 0
        return (autoInvoices / (invoices + autoInvoices)) * 100
      }
    },

    filteredInterventionsByArtisan() {
      const today = new Date()
      return this.artisan_interventions.filter(item => {
        return new Date(item.date_intervention).getDate() == today.getDate() &&  new Date(item.date_intervention).getMonth() == today.getMonth() && new Date(item.date_intervention).getFullYear() == today.getFullYear()
      })
    },

    ArtisanAFTotaleHt1() {
      var interventions = this.filteredInvoicesByArtisan.map((invoice, index) => {
        return invoice.intervention
      })

      return interventions.length ? interventions.reduce((sum, intervention) => sum + (intervention.auto_invoices.length ? intervention.auto_invoices[0].commission : 0), 0).toFixed(2)+ ' €' : '0.00 €'
    },

    filteredNbrsInterventionsForUser(){
      let colorschoice = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      let users = []
      let data = []
      let colors = []

      this.nbrsInterventionsForUser.map((user, index) => {
        if(user.role == 'User') {
          users.push(user.name)
          colors.push(colorschoice[index])
          var temp = Object.assign({}, user);
          temp.historiques = temp.historiques.filter(historique => {
            return this.format_date(historique.created_at) >= this.format_date(this.dateRange.startDate) && this.format_date(historique.created_at) <= this.format_date(this.dateRange.endDate) && historique.action == 'create'
          })
          data.push({ 'value' : temp.historiques.length, 'name' : user.name})
        }
      })

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: users
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            color: colors,
            label:{            
                normal:{
                    show:true,
                    // position:'inner', //Label location
                    textStyle : {
                        fontWeight : 700 ,
                        fontSize : 14   
                    },
                    formatter:'{b} : {c} ({d}%)'
                }
            },
            data: data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    
    },

    filteredCAForUser(){
      let colorschoice = ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E']
      let users = []
      let data = []
      let colors = []

      this.nbrsInterventionsForUser.map((user, index) => {
        if(user.role == 'User') {
          users.push(user.name)
          colors.push(colorschoice[index])
          var temp = Object.assign({}, user);
          temp.historiques = temp.historiques.filter(historique => {
            return this.format_date(historique.created_at) >= this.format_date(this.dateRange.startDate) && this.format_date(historique.created_at) <= this.format_date(this.dateRange.endDate) && historique.action == 'create'
          })
          let ht = temp.historiques.length ? temp.historiques.reduce((sum, intervention) => sum + (intervention.historiqueable.invoice ? intervention.historiqueable.invoice.ht : 0), 0) : 0
          
          data.push({ 'value' : ht.toFixed(2), 'name' : user.name})
        }
      })

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} € ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: users
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            color: colors,
            label:{            
                normal:{
                    show:true,
                    // position:'inner', //Label location
                    textStyle : {
                        fontWeight : 700 ,
                        fontSize : 14   
                    },
                    formatter:'{b} : {c} € ({d}%)'
                }
            },
            data: data,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    
    },
    
    intervenions_annuler_pie() {
      var trop_chere = this.interventions.filter(item => {
        var t1 = this.format_date(item.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date_intervention) <= this.format_date(this.dateRange.endDate) && item.status == 5
        var t2 = this.f_secteur_id ? item.secteur_id == this.f_secteur_id : true
        return t1 && t2
      }).length;
      var artisan_non_disponible = this.interventions.filter(item => {
        var t1 = this.format_date(item.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date_intervention) <= this.format_date(this.dateRange.endDate) && item.status == 6
        var t2 = this.f_secteur_id ? item.secteur_id == this.f_secteur_id : true
        return t1 && t2
      }).length;
      var client_annule = this.interventions.filter(item => {
        var t1 = this.format_date(item.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date_intervention) <= this.format_date(this.dateRange.endDate) && item.status == 7
        var t2 = this.f_secteur_id ? item.secteur_id == this.f_secteur_id : true
        return t1 && t2
      }).length;
      var hors_secteur = this.interventions.filter(item => {
        var t1 = this.format_date(item.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date_intervention) <= this.format_date(this.dateRange.endDate) && item.status == 8
        var t2 = this.f_secteur_id ? item.secteur_id == this.f_secteur_id : true
        return t1 && t2
      }).length;

      var concurrence = this.interventions.filter(item => {
        var t1 = this.format_date(item.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(item.date_intervention) <= this.format_date(this.dateRange.endDate) && item.status == 9
        var t2 = this.f_secteur_id ? item.secteur_id == this.f_secteur_id : true
        return t1 && t2
      }).length; 

      this.nbrInterAnnuler = trop_chere + artisan_non_disponible + client_annule + hors_secteur + concurrence

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: ['Trop chère', 'Artisan non disponible', 'Client annule', 'Hors secteur','Concurrence']
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            color: ['#FF9F43','#28C76F','#EA5455','#87ceeb','#0400ff'],
            label:{            
                normal:{
                    show:true,
                    // position:'inner', //Label location
                    textStyle : {
                        fontWeight : 700 ,
                        fontSize : 14   
                    },
                    formatter:'{b} : {c} ({d}%)'
                }
            },
            data: [
              {value: trop_chere, name: 'Trop chère'},
              {value: artisan_non_disponible, name: 'Artisan non disponible'},
              {value: client_annule, name: 'Client annule'},
              {value: hors_secteur, name: 'Hors secteur'},
              {value: concurrence, name: 'Concurrence'}
            ],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },
    
    intervenions_annuler_secteurs() {
      var i = 0
      var colors = ['#CC3300','#FF6633','#CC3333','#6600CC','#6600FF','#6699FF','#66CC00','#0066CC','#FFCC00','#CC66CC','#FFA07A','#FA8072','#8DC4DE','#7FFF00','#ADFF2F', '#FF0000','#00FF7F','#00FF7F','#ADD8E6','#6B8E23','#9ACD32','#32CD32','#00FF00']
      var secteurs = []
      var secteursData = []
      var secteursDataColors = []
      this.Secteurs.map((secteur, index) => {
        var temp = Object.assign({}, secteur);
        
        temp.interventions = temp.interventions.filter(intervention => {
          return (this.format_date(intervention.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.date_intervention) <= this.format_date(this.dateRange.endDate)) && (intervention.status == 5 || intervention.status == 6 || intervention.status == 7 || intervention.status == 8 || intervention.status == 9)
        })
        
        if(temp.interventions.length > 0) {
          secteurs.push(temp.name)
          secteursDataColors.push(colors[i])
          secteursData.push( {value: temp.interventions.length, name: temp.name})
          i++
        }
      })

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show:false,
          orient: 'vertical',
          left: 'left',
          data: secteurs
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            color: secteursDataColors,
            label:{            
                normal:{
                    show:true,
                    // position:'inner', //Label location
                    textStyle : {
                        fontWeight : 700 ,
                        fontSize : 14   
                    },
                    formatter:'{b} : {c} ({d}%)'
                }
            },
            data: secteursData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },

    getDates() {
      const dates = []
      let currentDate = this.dateRange.startDate

      const addDays = function (days) {
        const date = new Date(this.valueOf())
        date.setDate(date.getDate() + days)
        return date
      }
      while (currentDate <= this.dateRange.endDate) {
        dates.push(currentDate)
        currentDate = addDays.call(currentDate, 1)
      }
      return dates
    },

    daysLineArea() {
      var days = ['Dim.','Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'];
      let dates = this.getDates
      let categories = []
      let data = []
      dates.forEach(date => {
        
        var nbr = this.interventions.filter(item => {
          return this.format_date(item.created_at) >= this.format_date(date) && this.format_date(item.created_at) <= this.format_date(date) && (item.status == 2 || item.status == 3)
        }).length
        var shortDate = days[date.getDay()] +' '+ date.getDate() +'/'+ (date.getMonth() + 1)
        
        categories.push(shortDate)
        data.push({'x' : shortDate , 'y' : nbr})
      })
      

      return {
        series: [{
            name: 'Nombre des interventions',
            data: data
          }],
        chartOptions: {
          dataLabels: {
            enabled: true
          },
          stroke: {
            curve: 'smooth'
          },
          colors:  ['#7367F0', '#28C76F', '#EA5455', '#FF9F43', '#1E1E1E'],
          xaxis: {
            type: 'category',
            categories: categories,
          },
          tooltip: {
            x: {
              format: 'dd/MM/yy HH:mm'
            },

          }
        }
      }
    },
    
    intervenions_pris() {
      var i = 0
      this.nbrInterPris = 0
      var colors = ['#CC3300','#FF6633','#CC3333','#6600CC','#6600FF','#6699FF','#66CC00','#0066CC','#FFCC00','#CC66CC','#FFA07A','#FA8072','#8DC4DE','#7FFF00','#ADFF2F', '#FF0000','#00FF7F','#00FF7F','#ADD8E6','#6B8E23','#9ACD32','#32CD32','#00FF00']
      var secteurs = []
      var secteursData = []
      var secteursDataColors = []
      this.Secteurs.map((secteur, index) => {
        var temp = Object.assign({}, secteur);
        
        temp.interventions = temp.interventions.filter(intervention => {
          return (this.format_date(intervention.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.date_intervention) <= this.format_date(this.dateRange.endDate)) && (intervention.status == 2 || intervention.status == 3)
        })
        
        if(temp.interventions.length > 0) {
          this.nbrInterPris += temp.interventions.length
          secteurs.push(temp.name)
          secteursDataColors.push(colors[i])
          secteursData.push( {value: temp.interventions.length, name: temp.name})
          i++
        }
      })

      return {
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        legend: {
          show:false,
          orient: 'vertical',
          left: 'left',
          data: secteurs
        },
        series: [
          {
            name: '',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            color: secteursDataColors,
            label:{            
                normal:{
                    show:true,
                    // position:'inner', //Label location
                    textStyle : {
                        fontWeight : 700 ,
                        fontSize : 14   
                    },
                    formatter:'{b} : {c} ({d}%)'
                }
            },
            data: secteursData,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
    },
  
    secteurs_choice() {
      let list =  [{id: null , name: 'Tous'}]
      if(this.Secteurs.length) {
        this.Secteurs.map((secteur, index) => {
          var temp = Object.assign({}, secteur);
          
          temp.interventions = temp.interventions.filter(intervention => {
            return (this.format_date(intervention.date_intervention) >= this.format_date(this.dateRange.startDate) && this.format_date(intervention.date_intervention) <= this.format_date(this.dateRange.endDate)) && (intervention.status == 5 || intervention.status == 6 || intervention.status == 7 || intervention.status == 8 || intervention.status == 9)
          })
          
          if(temp.interventions.length > 0) {
            list.push({id: temp.id, name: temp.name})
          }
        })
      }
      return list
    }
  },
  methods: {
    ...mapActions('interventions', {'fetchInterventions' : 'fetchItems', 'fetchItemsByArtisan' : 'fetchItemsByArtisan', 'fetchItemsNbrsInterventions' : 'fetchItemsNbrsInterventions', 'fetchItemsHasInvoice' : 'fetchItemsHasInvoice', 'fetchItemsDoesntHaveInvoice' : 'fetchItemsDoesntHaveInvoice'}),
    ...mapActions('clients', {'fetchClients' : 'fetchItems', 'fetchCountClientsHaveInvoice' : 'fetchCountItemsHaveInvoice'}),
    ...mapActions('artisans', {'fetchArtisans' : 'fetchItems','fetchArtisansWithInterventions' : 'fetchItemsWithInterventions'}),
    ...mapActions('invoices', {'fetchInvoices' : 'fetchItems'}),
    ...mapActions('statistiques', {'fetchStatisArtisans': 'fetchItems', 'fetchStatisInterventions' : 'fetchInterventionsStatistics'}),
    ...mapActions('secteurs', {'fetchSecteurs': 'fetchItemsWithInterventions','fetchSecteursList' : 'fetchItems'}),

    format_date(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
          month = '0' + month;
      if (day.length < 2)
          day = '0' + day;

      return [year, month, day].join('-');
    },

    full_name_artisan(first,last) {
      return first +' '+last;
    },

    full_name_client(first,last) {
      return first +' '+last;
    },

    total_ht(invoice){
      return "kkk"+invoice.ht
    },

    closeCardAnimationDemo(card) {
      card.removeRefreshAnimation(3000);
    },

    genererAF(intervention_id, artisan_id) {
      this.$router.push({ name: 'auto-facture', params: {intervention_id: intervention_id,artisan_id: artisan_id }})
    },

    autoFactureId(intervention, artisan_id) {
      var invoice = intervention.auto_invoices.length ? intervention.auto_invoices.find(invoice =>  invoice.artisan_id == artisan_id ) : null
      return invoice ? {id: invoice.id ,num: invoice.num_auto_invoice} : {id: null, num: null}
    },

    showIntervention(intervention) {
      this.$router.push(`/mon-intervention/${intervention.id}`);
    },

    ToInterventions(artisan_id) {
      var search_object = {
        'num' : null,
        'artisans_id' : [artisan_id],
        'clients_id' : [],
        'etat' :{label: "Terminer", value: 3},
        'lieu' : null,
        'tel' : null,
        'zip' : null
      }

      localStorage.setItem("interventions_search", JSON.stringify(search_object))
      this.$router.push(`/interventions`);

    },

    ToAF(artisan_id) {
      var search_object = {
        'num' : null,
        'artisans_id' : [artisan_id],
        'clients_id' : [],
        'etat' : "issued",
        'fromDate' : this.dateRange.startDate,
        'toDate' : this.dateRange.endDate
      }

      localStorage.setItem("auto_factures_search", JSON.stringify(search_object))
      this.$router.push(`/auto-factures`);
    }

  },
  created () {
    this.user_role = this.$cookies.get('role')

    if(this.user_role === 'Admin' || this.user_role === 'User') {
      this.fetchInterventions()
      this.fetchClients()
      this.fetchCountClientsHaveInvoice()
      this.fetchArtisans()
      this.fetchInvoices()
      this.fetchStatisArtisans()
      this.fetchArtisansWithInterventions()
      this.fetchItemsNbrsInterventions()
      this.fetchItemsHasInvoice()
      this.fetchItemsDoesntHaveInvoice()
      this.fetchStatisInterventions().then(() => {
        this.lineAreaChartSpline.series = this.statis_interventions.series
      })
      this.fetchSecteurs()
    }

    if(this.user_role === 'Artisan') {
      this.fetchItemsByArtisan()
      this.fetchInvoices()
    }

  },
  filters: {
    dateCell (value) {
      let dt = new Date(value)

      return dt.getDate()
    },
    date(value) {
      var [date, time] = value.split("T")
      var [y, m, d] = date.split("-")
      var [h, min] = time.split(":")
      return d +'/'+ m +'/'+ y +' '+ h +':'+ min
    },

    strPadStart(value, pattern = ""){ // Use padStart to complete the string
      return value.toString().padStart(4,pattern)
    },

  },
 

}
</script>
<style>

  .num_object:hover{
    color: #be092f;
    text-shadow: -0.25px -0.25px 0 #be092f, 0.25px 0.25px #be092f;
  }

.vue-daterange-picker{
   float: right !important
}

.slot {
  background-color: #aaa;
  padding: 0.5rem;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.text-black {
  color: #000;
}


@media only screen and (min-width: 600px) {
  .daterangepicker.openscenter[data-v-4391f606] {
      right: auto;
      left: 0%;
      -webkit-transform: translate(-73%);
      transform: translate(-73%);
  }
}

[dir] .daterangepicker td.active, [dir] .daterangepicker td.active:hover {
    background-color: rgba(var(--vs-primary), 1);
    border-color: transparent;
}

[dir] .daterangepicker .btn-primary, [dir] .daterangepicker .btn-success {
    background-color: rgba(var(--vs-danger),1);
}

.feather-icon .feather-rotate-cw, .feather-icon .feather-x {
  display: none;
}

[dir=ltr] .vx-card .vx-card__header .vx-card__actions .vx-card__action-buttons .feather-icon {
    margin-left: 5px !important;
}

[dir=ltr] .vs-con-table .vs-table--header, [dir=rtl] .vs-con-table .vs-table--header {
  margin-bottom: 1.5rem;
}

.calendars {
  flex-wrap: nowrap !important;
}

</style>
